import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, map } from 'rxjs';
import { InvoicingServiceData } from '../interfaces/invoicingService-data.model';
import { plainToInstance } from 'class-transformer';
import { InvoicingServicesResponse } from '../interfaces/invoicingService-response.model';

@Injectable({
  providedIn: 'root',
})
export class AttendanceServicesService {
  private apiUrl = `${environment.sgcApi}`;
  private invoicingServiceRoute = 'invoicingService';

  constructor(private httpClient: HttpClient) {}

  getAttendanceServicesByFilter(
    year: number,
    month: number,
    schoolId: number,
    exerciseId: number
  ): Observable<InvoicingServiceData[]> {
    let endpoint = `${this.apiUrl}${this.invoicingServiceRoute}/year/${year}/month/${month}/schoolId/${schoolId}/exerciseId/${exerciseId}`;

    return this.httpClient.get<InvoicingServiceData[]>(endpoint).pipe(
      map((invoicingService) => {
        return plainToInstance(
          InvoicingServiceData,
          invoicingService as InvoicingServiceData[]
        );
      })
    );
  }

  saveAttendancesServices(
    user: string,
    invoicingServicesResponse: InvoicingServicesResponse
  ) {
    let endpoint = `${this.apiUrl}${this.invoicingServiceRoute}/user/${user}`;
    return this.httpClient.put(
      endpoint,
      JSON.stringify(invoicingServicesResponse)
    );
  }
}
